import { gql } from "@/services/httpAdapter";

const VehicleInfoFragment = gql`
	fragment VehicleInfo on VehicleInfo {
		_id
		stockNumber
		vinNumber
		year
		make
		model
		trim
		color
		type
		status
	}
`;

const KeyStatesFragment = gql`
	fragment KeyStates on KeyStates {
		_id
		kioskId
		isConsistent
		lastEvent
		createdBy
		userId
		creationDate
		completionDate
	}
`;

const ReconciliationNoteFragment = gql`
	fragment ReconciliationNote on ReconciliationNotes {
		_id
		reconciliationId
		locationId
		commissionCycleId
		payPeriodId
		notes {
			_id
			note
			createdByFullName
			createdBy
			createdAt
		}
	}
`;

const LotInfoFragment = gql`
	fragment LotInfo on LotInfo {
		_id
		name
		address
		locationId
	}
`;

export const ReconciliationFragment = gql`
	fragment Reconciliation on Reconciliation {
		_id
		locationId
		commissionCycleId
		payPeriodId
		createdAt
		reconciliationDate
		updatedAt
		updatedBy
		vehicle {
			...VehicleInfo
		}
		reason
		resolution
		status
		reconciled
		manuallyReconciled
		hasNotes
		notesId
		notes {
			...ReconciliationNote
		}
		keyStates {
			...KeyStates
		}
		inventoryId
		dmsId
		gpsId
		kmsAssetId
		lot {
			...LotInfo
		}
		gps {
			address
			gpsVehicleType
		}
		balance
	}
	${VehicleInfoFragment}
	${ReconciliationNoteFragment}
	${KeyStatesFragment}
	${LotInfoFragment}
`;
